module.exports = __webpack_public_path__ + "fonts/iconfont.1f5d7679.eot";